/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import useCustomResources from "@/shared/hooks/useCustomResources/useCustomResources";

import {
  ACTIVITY_STATUS,
  IGeneralDetailsProps
} from "../../../../../../shared";
import SharedStatusBadge from "../../../../../SharedStatusBadge/SharedStatusBadge";
import { useStyles } from "../../../../styles";
import DetailsCard from "../DetailsCard";
import DetailsCardItemText from "../DetailsCardItemText";
import DetailsCardItemTitle from "../DetailsCardItemTitle";

const VehicleGeneralDetails = ({ detailsData }: IGeneralDetailsProps) => {
  const { t } = useTranslation();

  const { paperCardItem, paperCardItemFixedHeight } = useStyles();

  const { renderImeiOrTooltip } = useCustomResources();

  const hasImei = Boolean(detailsData?.imei);

  return (
    <DetailsCard cardTitle={t("Details##general")} detailsData={detailsData}>
      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Details##company")} />
        <DetailsCardItemText textToRender={detailsData?.company?.name} />
      </div>

      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Details##vrn")} />
        <DetailsCardItemText textToRender={detailsData?.number} />
      </div>

      <div css={css([paperCardItem, paperCardItemFixedHeight])}>
        <DetailsCardItemTitle title={t("Details##device imei")} />
        {hasImei ? (
          <DetailsCardItemText
            hasCopyButton
            textToRender={detailsData?.imei}
            copiedValue={detailsData?.imei}
          />
        ) : (
          renderImeiOrTooltip(detailsData?.imei)
        )}
      </div>

      <div css={css([paperCardItem, paperCardItemFixedHeight])}>
        <DetailsCardItemTitle title={t("Details##device status")} />
        {detailsData?.status ? (
          <SharedStatusBadge status={detailsData?.status as ACTIVITY_STATUS} />
        ) : (
          "-"
        )}
      </div>
    </DetailsCard>
  );
};

export default VehicleGeneralDetails;
